import { isValidEmailAddress } from '@blissbook/lib/sanitize'
import * as Yup from 'yup'

Yup.addMethod(Yup.string, 'email', function () {
  return this.test('email', 'Invalid Email Address', (email) => {
    if (!email) return false
    return isValidEmailAddress(email)
  })
})
